import Dashboard from '../../components/dashboard/Dashboard';

export default function DashboardPage() {
  return <Dashboard />;
}
